import _extends from 'babel-runtime/helpers/extends';

import MForm from 'm-form';

export default {
  components: {
    MForm: MForm
  },

  props: {
    demand: {
      type: Object,
      required: true
    },

    readOnly: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      formConfig: {
        size: 'small'
      }
    };
  },


  computed: {
    formItemList: function formItemList() {
      var _this = this;

      return [{
        visible: true,
        label: '垂类：',
        type: 'input',
        prop: 'meta_cl',
        rules: [{
          required: true,
          message: '请输入垂类',
          trigger: 'blur'
        }]
      }, {
        visible: true,
        label: '品类：',
        type: 'input',
        prop: 'meta_pl',
        rules: [{
          required: true,
          message: '请输入品类',
          trigger: 'blur'
        }]
      }, {
        visible: true,
        label: '题材/风格：',
        type: 'input',
        prop: 'meta_tc',
        rules: [{
          required: true,
          message: '请输入题材/风格',
          trigger: 'blur'
        }]
      }].map(function (item) {
        if (_this.readOnly) delete item.rules;
        return _extends({}, item, {
          type: _this.readOnly ? 'plain-text' : item.type
        });
      });
    }
  },

  methods: {
    validate: function validate(cb) {
      return this.$refs.form.validate(cb);
    }
  }
};